export function isManagerResidentsMockEnabled(): boolean {
  return process.env.NODE_ENV === 'development';
}
